import React, { Component } from 'react';
import { Button, Form, Input, message, Row, Tabs } from 'antd';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { queryProjLauList } from '@api/task';
import { setBackInfo } from '@store/modules/back_info';
import TableProj from './TableProj';

const { TabPane } = Tabs;
const FormItem = Form.Item;

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'PUBLISH',
      tabKey: '1',
      current: 1,
      isLoading: false,
      condition: '',
      pagination: {
        total: 10,
        current: 1,
        PageSize: 10,
      },
      list: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.setState(
        {
          status: backInfo.status,
          tabKey: backInfo.tabKey,
          current: backInfo.current,
          condition: backInfo.condition,
        },
        () => {
          this.loadData();
        },
      );
    } else {
      this.loadData();
    }
  }

  componentWillUnmount() {
    const { status, tabKey, current, condition } = this.state;
    const params = {
      path: this.props.location.pathname,
      status,
      tabKey,
      current,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  // 加载数据
  loadData = () => {
    const { status, current, condition } = this.state;
    const limit = 10;
    this.setState({
      isLoading: true,
    });
    queryProjLauList({
      status,
      start: current,
      limit,
      name: condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          list: res.data,
          pagination: {
            total: res.totalSize,
            current,
            pageSize: 10,
          },
        });
      } else {
        message.error(res.message);
      }
      this.setState({
        isLoading: false,
      });
    });
  };

  // 搜索
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            current: 1,
            condition: values.name,
          },
          () => {
            this.loadData();
          },
        );
      }
    });
  };

  // tab栏切换
  changeTabs = key => {
    switch (key) {
      case '1':
        this.setState(
          {
            status: 'PUBLISH',
            tabKey: '1',
            current: 1,
          },
          () => {
            this.loadData();
          },
        );
        break;
      case '2':
        this.setState(
          {
            status: 'FINISH',
            tabKey: '2',
            current: 1,
          },
          () => {
            this.loadData();
          },
        );
        break;
      case '3':
        this.setState(
          {
            status: 'DRAFT',
            tabKey: '3',
            current: 1,
          },
          () => {
            this.loadData();
          },
        );
        break;
      default:
        break;
    }
  };

  // 列表改变
  changeTable = pagination => {
    this.setState(
      {
        current: pagination.current,
      },
      () => {
        this.loadData();
      },
    );
  };

  // 关注按钮
  isFocusOn = record => {
    record.isFocusOn = 1;
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <Form
        onSubmit={this.handleSubmit}
        style={{
          position: 'absolute',
          right: '10px',
          top: '0',
          display: 'flex',
          zIndex: 100,
        }}
      >
        <FormItem>
          {getFieldDecorator('name', {
            initialValue: condition,
          })(<Input placeholder="请输入项目名称" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
            搜索
          </Button>
        </FormItem>
      </Form>
    );
  };

  render() {
    const { list, tabKey, pagination, isLoading } = this.state;
    return (
      <div>
        <Row type="flex" style={{ marginBottom: '10px' }}>
          {/* <Button style={{ marginRight: "10px" }}>项目模板</Button> */}
          <Link to="/task/project_add">
            <Button style={{ marginRight: '10px' }} type="primary">
              创建项目
            </Button>
          </Link>
        </Row>
        <div style={{ position: 'relative' }}>
          {this.renderSearchForm()}
          <Tabs defaultActiveKey="1" activeKey={tabKey} onChange={this.changeTabs}>
            <TabPane tab="发布中" key="1">
              <TableProj
                data={list}
                type="launch"
                isLoading={isLoading}
                pagination={pagination}
                loadData={this.loadData}
                onChange={this.changeTable}
                {...this.props}
              />
            </TabPane>
            <TabPane tab="已结束" key="2">
              <TableProj
                data={list}
                type="launch"
                type2="finish"
                isLoading={isLoading}
                pagination={pagination}
                loadData={this.loadData}
                onChange={this.changeTable}
                {...this.props}
              />
            </TabPane>
            <TabPane tab="草稿箱" key="3">
              <TableProj
                data={list}
                type="launch"
                isLoading={isLoading}
                pagination={pagination}
                loadData={this.loadData}
                onChange={this.changeTable}
                {...this.props}
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create()(Page));



// WEBPACK FOOTER //
// ./src/components/task/project/PageLaunch.js